import React from 'react'
import { Widget } from 'features/types'
import { useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import { SocialWebPhotoConceptsWidget } from '../../../../schemas/SocialWebPhotoConceptsWidgetSchema'
import DisplayOption from '../../../../enums/DisplayOption'
import TableDisplay from './TableDisplay'
import WordCloudDisplay from './WordCloudDisplay'

const SocialWebPhotoConcept: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebPhotoConceptsWidget>(widgetId)

  switch (widgetSetting.displayOption) {
    case DisplayOption.TABLE:
      return <TableDisplay widgetId={widgetId} />
    case DisplayOption.WORDCLOUD:
      return <WordCloudDisplay widgetId={widgetId} />
    default:
      throw new Error(`Unsupported display option: ${widgetSetting.displayOption}`)
  }
}

export default SocialWebPhotoConcept
